import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface UpdateTestInputDto {
  parameters: Record<string, string | null>;
}

export interface RenameTestInputDto {
  name: string;
}

@Injectable({ providedIn: 'root' })
export class TestInputService {
  private readonly api = inject(ApiService);

  start(id: number): Observable<void> {
    return this.api.post(`testinputs/${id}/start`, {});
  }

  updateParameters(id: number, dto: UpdateTestInputDto): Observable<void> {
    return this.api.put(`testinputs/${id}/parameters`, dto);
  }

  rename(id: number, dto: RenameTestInputDto): Observable<void> {
    return this.api.put(`testinputs/${id}/rename`, dto);
  }

  cancel(id: number): Observable<void> {
    return this.api.post(`testinputs/${id}/cancel`, {});
  }

  complete(id: number, dto: UpdateTestInputDto): Observable<void> {
    return this.api.put(`testinputs/${id}/complete`, dto);
  }
}
